<div class="relative overflow-hidden bg-stone-bg">
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
    <div class="absolute -top-24 right-0 w-72 h-72 bg-primary/10 rounded-full blur-3xl"></div>
  </div>

  <div class="section !pb-16">
    <div class="container-max">
      <app-breadcrumbs [crumbs]="crumbs" />

      <h1 class="font-sans text-headline-lg mb-2">Vacantes de empleo en LATAM</h1>
      <p class="text-on-surface-variant mb-8 max-w-xl">
        Explora {{ resultado.totalItems }} vacantes disponibles y postula gratis por WhatsApp.
      </p>

      <!-- Search bar -->
      <div class="relative mb-6">
        <span class="material-symbols-outlined absolute left-5 top-1/2 -translate-y-1/2 text-on-surface-variant">search</span>
        <input
          type="search"
          class="w-full rounded-full bg-white border border-outline-variant/50 shadow-soft pl-14 pr-5 py-4 text-sm focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none transition-all"
          placeholder="Busca por puesto, empresa o habilidad (ej. 'soldador en CDMX')"
          [ngModel]="filtros.q"
          (ngModelChange)="onSearchInput($event)"
          aria-label="Buscar vacantes"
        />
      </div>
    </div>
  </div>
</div>

<div class="section !pt-10">
  <div class="container-max">
    <div class="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-8">
      <!-- Filters -->
      <aside class="bg-white rounded-3xl shadow-soft border border-outline-variant/30 p-6 h-fit lg:sticky lg:top-24">
        <h2 class="font-bold mb-5 flex items-center gap-2">
          <span class="material-symbols-outlined text-primary">tune</span>
          Filtros
        </h2>

        <div class="mb-5">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Sector</label>
          <select
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            [ngModel]="filtros.sector"
            (ngModelChange)="filtros.sector = $event; onFilterChange()"
          >
            <option [ngValue]="undefined">Todos los sectores</option>
            @for (cat of categorias; track cat.id) {
              <option [ngValue]="cat.id">{{ cat.nombre }}</option>
            }
          </select>
        </div>

        <div class="mb-5">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">País</label>
          <select
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            [ngModel]="filtros.pais"
            (ngModelChange)="onPaisChange($event)"
          >
            <option value="">Todos los países</option>
            @for (pais of paises; track pais.code) {
              <option [value]="pais.code">{{ pais.flag }} {{ pais.nombre }}</option>
            }
          </select>
        </div>

        <div class="mb-5 relative">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Ciudad</label>
          <input
            type="text"
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            placeholder="Ej. Bogotá"
            [ngModel]="ciudadTexto"
            (ngModelChange)="onCiudadInput($event)"
            (blur)="ocultarSugerenciasConDelay()"
            (focus)="onCiudadFocus()"
            autocomplete="off"
          />
          @if (sinCoincidenciasCiudad()) {
            <p class="mt-1.5 text-xs text-error" role="alert">No se encontraron ciudades que coincidan</p>
          }
          @if (sugerenciasUbicacion().length > 0) {
            <ul class="absolute z-10 mt-1 w-full bg-white rounded-xl shadow-soft border border-outline-variant/30 max-h-56 overflow-y-auto">
              @for (s of sugerenciasUbicacion(); track s.etiqueta) {
                <li>
                  <button type="button" class="w-full text-left px-3 py-2 text-sm hover:bg-surface-container-low"
                    (click)="elegirUbicacion(s)">
                    {{ s.etiqueta }}
                  </button>
                </li>
              }
            </ul>
          }
        </div>

        <div class="mb-5">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Modalidad</label>
          <select
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            [ngModel]="filtros.modalidad"
            (ngModelChange)="filtros.modalidad = $event; onFilterChange()"
          >
            <option [ngValue]="undefined">Cualquiera</option>
            <option value="PRESENCIAL">Presencial</option>
            <option value="REMOTO">Remoto</option>
            <option value="HIBRIDO">Híbrido</option>
          </select>
        </div>

        <div class="mb-5">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Tipo de contrato</label>
          <select
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            [ngModel]="filtros.tipoContrato"
            (ngModelChange)="filtros.tipoContrato = $event; onFilterChange()"
          >
            <option [ngValue]="undefined">Cualquiera</option>
            <option value="tiempo_completo">Tiempo completo</option>
            <option value="medio_tiempo">Medio tiempo</option>
            <option value="por_proyecto">Por proyecto</option>
            <option value="freelance">Freelance</option>
          </select>
        </div>

        <div class="mb-5">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Nivel</label>
          <select
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            [ngModel]="filtros.seniority"
            (ngModelChange)="filtros.seniority = $event; onFilterChange()"
          >
            <option [ngValue]="undefined">Cualquiera</option>
            <option value="JUNIOR">Junior</option>
            <option value="MID">Semi-senior</option>
            <option value="SENIOR">Senior</option>
            <option value="LEAD">Lead</option>
          </select>
        </div>

        <div class="mb-5">
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Rango de salario</label>
          <div class="flex items-center gap-2">
            <input
              type="number"
              min="0"
              class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
              placeholder="Mínimo"
              [ngModel]="filtros.salarioMin"
              (ngModelChange)="filtros.salarioMin = $event; onSalaryFilterChange()"
              aria-label="Salario mínimo"
            />
            <span class="text-on-surface-variant">–</span>
            <input
              type="number"
              min="0"
              class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
              placeholder="Máximo"
              [ngModel]="filtros.salarioMax"
              (ngModelChange)="filtros.salarioMax = $event; onSalaryFilterChange()"
              aria-label="Salario máximo"
            />
          </div>
        </div>

        <div>
          <label class="text-xs font-bold uppercase text-on-surface-variant mb-2 block tracking-wide">Ordenar por</label>
          <select
            class="w-full rounded-xl border border-outline-variant/50 bg-surface-container-low px-3 py-2.5 text-sm focus:border-primary focus:outline-none"
            [ngModel]="filtros.sortBy"
            (ngModelChange)="filtros.sortBy = $event; onFilterChange()"
          >
            <option value="relevancia">Relevancia</option>
            <option value="recencia">Más recientes</option>
            <option value="salario">Mayor salario</option>
            <option value="match">Mejor match</option>
          </select>
        </div>
      </aside>

      <!-- Results -->
      <div>
        @if (loading) {
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            @for (i of [1,2,3,4]; track i) {
              <div class="rounded-3xl h-44 animate-pulse bg-surface-container-low"></div>
            }
          </div>
        } @else if (resultado.items.length === 0) {
          <div class="bg-white rounded-3xl shadow-soft border border-outline-variant/30 text-center py-20 px-6">
            <div class="w-16 h-16 rounded-full bg-teal-surface text-primary flex items-center justify-center mx-auto mb-5">
              <span class="material-symbols-outlined text-3xl">search_off</span>
            </div>
            <h3 class="font-bold text-lg mb-2">No encontramos vacantes con esos filtros</h3>
            <p class="text-on-surface-variant text-sm max-w-sm mx-auto">
              Prueba ajustando los filtros o vuelve más tarde — publicamos nuevas vacantes todos los días.
            </p>
          </div>
        } @else {
          <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3.5 mb-8">
            @for (vacante of resultado.items; track vacante.id) {
              <app-job-card [vacante]="vacante" />
            }
          </div>

          @if (resultado.totalPages > 1) {
            <nav class="flex justify-center items-center gap-3" aria-label="Paginación de vacantes">
              <button
                type="button"
                class="w-11 h-11 rounded-full border-2 border-primary text-primary flex items-center justify-center transition-colors hover:bg-primary/5 disabled:opacity-30 disabled:cursor-not-allowed"
                [disabled]="resultado.page === 0"
                (click)="goToPage(resultado.page - 1)"
              >
                <span class="material-symbols-outlined">chevron_left</span>
              </button>
              <span class="text-sm text-on-surface-variant px-2 font-mono">
                {{ resultado.page + 1 }} / {{ resultado.totalPages }}
              </span>
              <button
                type="button"
                class="w-11 h-11 rounded-full border-2 border-primary text-primary flex items-center justify-center transition-colors hover:bg-primary/5 disabled:opacity-30 disabled:cursor-not-allowed"
                [disabled]="resultado.page >= resultado.totalPages - 1"
                (click)="goToPage(resultado.page + 1)"
              >
                <span class="material-symbols-outlined">chevron_right</span>
              </button>
            </nav>
          }
        }
      </div>
    </div>
  </div>
</div>
